import { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

function InitialLanguageRedirector() {
  const { i18n } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const hasRedirected = useRef(false);
  const [geoChecked, setGeoChecked] = useState(
    localStorage.getItem('pawfriends_geo_checked') === 'true'
  );

  useEffect(() => {
    if (geoChecked) return;

    const handleGeoComplete = () => {
      setGeoChecked(true);
    };

    window.addEventListener('pawfriends_geo_complete', handleGeoComplete);
    return () => {
      window.removeEventListener('pawfriends_geo_complete', handleGeoComplete);
    };
  }, [geoChecked]);

  useEffect(() => {
    // Only redirect if geo check has been performed and we haven't redirected in this lifecycle
    if (!geoChecked || hasRedirected.current) return;
    hasRedirected.current = true;

    // Only redirect if i18n detected 'en' BUT the current path doesn't have the '/en' prefix
    if (i18n.language === 'en' && !location.pathname.startsWith('/en')) {
      const newPath = '/en' + (location.pathname === '/' ? '' : location.pathname);
      navigate(newPath + location.search, { replace: true });
    }
  }, [geoChecked, i18n.language, location.pathname, location.search, navigate]);

  return null; // This component doesn't render anything
}

export default InitialLanguageRedirector;
